export default {
  // Endpoints
  getOrderEndpoint: 'order/paid',
  amount: 'add_amount',
}
